import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { useSafeArea } from "app/layout/Navbar/useSafeArea";
export const PageContainer = ({ children, ...rest }) => {
    const { insetTop } = useSafeArea();
    return (_jsx(Box, { component: "main", sx: { flexGrow: 1, py: `${96 + insetTop}px`, width: "100%" }, ...rest, children: children }));
};
